"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FINANCIAL_PAYMENT_CORRECTION_REQUEST_EXAMPLES = exports.listPaymentCorrectionsQuerySchema = exports.paymentCorrectionStatusEnum = exports.rejectPaymentCorrectionSchema = exports.approvePaymentCorrectionSchema = exports.requestPaymentCorrectionSchema = void 0;
/**
 * Request contracts for the Payment Correction Request / SuperAdmin
 * Approval workflow. `FinPaymentLine` (payment mode/bank account/reference
 * number) is application-enforced append-only because payment mode drives
 * GL posting (`SettlementAccountResolver`) — this is the only sanctioned
 * path to correct one after collection. Modeled on the OP Refund Request
 * workflow's own request/approve/reject shape
 * (`financial-refund-request.request.ts`) — the closest in-module
 * precedent for "create PENDING, only approval moves anything real".
 *
 * `create()` never auto-approves and never posts anything, same rule as
 * that file's own header. `approve()` is the only path that posts a
 * reclassifying journal entry and updates the payment line — see
 * `PaymentCorrectionService`.
 */
const zod_1 = require("zod");
exports.requestPaymentCorrectionSchema = zod_1.z.object({
    paymentLineId: zod_1.z.string().uuid(),
    requestedPaymentModeId: zod_1.z.string().uuid(),
    /** Required for every non-cash mode; `SettlementAccountResolver` enforces this the same way collection itself does. */
    requestedBankAccountId: zod_1.z.string().uuid().optional(),
    requestedReferenceNumber: zod_1.z.string().trim().max(100).optional(),
    reason: zod_1.z.string().trim().min(3, 'A reason is required').max(2000),
});
exports.approvePaymentCorrectionSchema = zod_1.z.object({
    decisionReason: zod_1.z.string().trim().max(2000).optional(),
});
exports.rejectPaymentCorrectionSchema = zod_1.z.object({
    /** Mandatory — same posture as `rejectRefundRequestSchema`: a reject the requester can't understand isn't a real decision. */
    decisionReason: zod_1.z.string().trim().min(1, 'A rejection reason is required').max(2000),
});
exports.paymentCorrectionStatusEnum = zod_1.z.enum(['PENDING', 'APPROVED', 'REJECTED']);
exports.listPaymentCorrectionsQuerySchema = zod_1.z.object({
    status: exports.paymentCorrectionStatusEnum.optional(),
    limit: zod_1.z.coerce.number().int().positive().max(200).default(50),
});
exports.FINANCIAL_PAYMENT_CORRECTION_REQUEST_EXAMPLES = {
    request: {
        paymentLineId: '11111111-1111-1111-1111-111111111111',
        requestedPaymentModeId: '22222222-2222-2222-2222-222222222222',
        requestedBankAccountId: '33333333-3333-3333-3333-333333333333',
        requestedReferenceNumber: '663758339099',
        reason: 'Patient reported wrong payment mode at collection — actually paid by UPI, not cash.',
    },
    approve: { decisionReason: 'Verified against bank statement.' },
    reject: { decisionReason: 'UTR does not match any settlement for this date.' },
};
//# sourceMappingURL=financial-payment-correction.request.js.map